
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-compare/[firstid]/[secondid]",
      function () {
        return require("private-next-pages/gangwon-compare/[firstid]/[secondid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-compare/[firstid]/[secondid]"])
      });
    }
  